import React from "react";
import { Box, Rating, RatingProps } from "@mui/material";

type CustomRatingComponentProps = RatingProps & {};

export const CustomRatingComponent = (props: CustomRatingComponentProps) => (
  <Box>
    <Rating {...props} />
  </Box>
);

export default CustomRatingComponent;
